import signedFetch from '../util/signedFetch.js';

export default orgId => signedFetch('getOrgUsage', `${__API_BASE__}/org/${encodeURIComponent(orgId)}/usage`, 'GET');
